import { TextValue } from "../tableElements";
import FilterItem from "./FilterItem.vue";
import { truncateString } from "@/utils";
import TargetingFilterBody from "./bodies/TargetingFilterBody.vue";
import FiltersMixin from "@/mixins/FiltersMixin.vue";
export default {
  name: "TargetingFilter",
  components: {
    FilterItem,
    TargetingFilterBody,
    TextValue
  },
  emits: ["apply", "cleared"],
  expose: ["openDropdown"],
  mixins: [FiltersMixin],
  props: {
    targetings: {
      type: Object,
      // Filter Type (@/store/filter.js)
      required: true
    },
    sellers: {
      type: Object,
      // Filter Type (@/store/filter.js)
      required: true
    },
    marketplaces: {
      type: Object,
      // Filter Type (@/store/filter.js)
      required: true
    },
    title: {
      type: String,
      default: "Targeting"
    }
  },
  computed: {
    getTargetingTitle() {
      return this.getTargeting ?? this.title;
    },
    getTargeting() {
      return this.targetings.selected?.[0];
    },
    getTargetingSelectedTitle() {
      const joined = this.targetings.selected?.map(el => el?.targeting).join(", ");
      return joined ? truncateString(joined, 200) : "";
    }
  },
  methods: {
    truncateString,
    onClear() {
      this.targetings.clear();
      this.$emit('cleared');
    },
    onRestoreSearch() {
      this.targetings.restoreSearch();
    },
    handleSearch({
      value
    }) {
      if (value.length === 0) {
        this.targetings.searching = false;
      }
      this.targetings.asyncSearch({
        keyword: value,
        args: {
          sellers: this.sellers.filterValues,
          sales_channel: this.marketplaces.filterValues
        }
      });
    },
    handleSelect({
      targeting,
      keyword_id_list,
      id
    }) {
      this.targetings.select({
        targeting,
        keyword_id_list,
        id
      });
    },
    handleSelectOnly({
      targeting,
      keyword_id_list,
      id
    }) {
      this.targetings.selectOnly({
        targeting,
        keyword_id_list,
        id
      });
    },
    handleDeselect({
      targeting,
      keyword_id_list,
      id
    }) {
      this.targetings.deselect({
        targeting,
        keyword_id_list,
        id
      });
      if (this.targetings?.filterState?.selected.length === 0) {
        this.$emit('cleared');
      }
    },
    onDiscard() {
      // Revert the staged pending changes back to the last-applied selection.
      this.targetings.clearDraft();
    },
    onHidden() {
      this.targetings.clearDraft();
    },
    onApply() {
      this.$emit('apply');
    },
    openDropdown(initializer = async () => {}, callback = () => {}) {
      this.openAsyncFilterDropdown(this.$refs.targetingFilterItem, initializer, callback);
    }
  }
};